export abstract class BaseError extends Error {
  public abstract tag: string;
}
